import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/client';
import ConfirmDialog from '../common/ConfirmDialog';

export default function DJsList() {
  const [djs, setDjs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmItem, setConfirmItem] = useState(null);

  useEffect(() => {
    fetchDjs();
  }, []);

  const fetchDjs = async () => {
    try {
      const { data } = await api.get('/api/djs');
      setDjs(data || []);
    } catch (err) {
      console.error('[DJsList] Failed to fetch:', err);
    } finally {
      setLoading(false);
    }
  };

  const toggleActive = async (dj) => {
    try {
      await api.put(`/api/djs/${dj.id}`, { is_active: !dj.is_active });
      fetchDjs();
    } catch (err) {
      console.error('[DJsList] Toggle failed:', err);
    }
  };

  const confirmDelete = async () => {
    if (!confirmItem) return;
    try {
      await api.delete(`/api/djs/${confirmItem.id}`);
      setDjs(djs.filter((d) => d.id !== confirmItem.id));
    } catch (err) {
      console.error('[DJsList] Delete failed:', err);
    } finally {
      setConfirmOpen(false);
      setConfirmItem(null);
    }
  };

  if (loading) {
    return <div className="flex min-h-[300px] items-center justify-center"><p className="text-dark-400">Cargando DJs...</p></div>;
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-dark-100">DJs</h1>
          <p className="text-sm text-dark-400 mt-1">Creá los DJs solo con su nombre. El acceso (correo/contraseña) se vincula más adelante.</p>
        </div>
        <Link to="/djs/create" className="btn btn-primary btn-sm">+ Nuevo DJ</Link>
      </div>

      {djs.length === 0 ? (
        <div className="py-12 text-center text-dark-400">No hay DJs. Creá el primero con su nombre.</div>
      ) : (
        <div className="overflow-x-auto rounded-xl bg-dark-850 border border-dark-700">
          <table className="table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Cuenta vinculada</th>
                <th>Series</th>
                <th>Estado</th>
                <th className="text-right">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {djs.map((dj) => (
                <tr key={dj.id}>
                  <td className="font-medium text-dark-100">{dj.stage_name}</td>
                  <td className="text-sm text-dark-400">
                    {dj.user_email ? `${dj.user_email}` : <span className="text-dark-600">Sin cuenta (acceso pendiente)</span>}
                  </td>
                  <td className="text-sm text-dark-400">{dj.show_count || 0}</td>
                  <td>
                    <button
                      type="button"
                      onClick={() => toggleActive(dj)}
                      className={`text-xs px-2 py-0.5 rounded ${dj.is_active ? 'bg-success-900/30 text-success-400' : 'bg-dark-700 text-dark-500'}`}
                    >
                      {dj.is_active ? '● Activo' : '○ Inactivo'}
                    </button>
                  </td>
                  <td className="text-right whitespace-nowrap">
                    <Link to={`/djs/${dj.id}/edit`} className="btn btn-secondary btn-sm mr-1">✎ Editar</Link>
                    <button type="button" onClick={() => { setConfirmItem(dj); setConfirmOpen(true); }} className="btn btn-error btn-sm">✕</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <ConfirmDialog
        open={confirmOpen}
        title="Eliminar DJ"
        message={`¿Seguro que quieres eliminar "${confirmItem?.stage_name}"?`}
        danger
        onConfirm={confirmDelete}
        onClose={() => setConfirmOpen(false)}
      />
    </div>
  );
}
